package it.neckar.projects.common

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

/**
 * Represents a port
 */
@JvmInline
@Serializable
value class Port(val value: Int) {
  operator fun plus(value: Int): Port {
    return Port(this.value + value)
  }

  override fun toString(): String {
    return value.toString()
  }

  //Required for extension methods
  companion object {
    val Http: Port = Port(80)
    val Https: Port = Port(443)

    fun of(value: Int): Port {
      return Port(value)
    }
  }
}
